module.exports = __webpack_public_path__ + "media/images/countryrect/jp-8d7a05fcc355a393823d53cac7c880e3.svg";